import {mkEl} from './functions';
import {Media} from '../interfaces/misc';
import {AxjHandler} from './ajax';

declare var wp: any;

export interface Params {
    input_name: string;
    files?: string;
    remove_all?: boolean;
}

export class MediaHandler extends AxjHandler {
    uploader: any;
    media: Media[] = [];
    button: HTMLElement;
    container: HTMLElement;
    params: Params = {
        input_name: 'media'
    }

    constructor(button: HTMLElement, container: HTMLElement, params?: Params) {
        super();
        this.setLocalizedParameters('staAdm');
        this.button = button;
        this.container = container;
        if (params) {
            this.params = params;
            if (params.files) {
                this.media = JSON.parse(params.files);
            }
        }
        this.init();
    }

    init() {
        this.createUploader();
        this.initListeners();
        if (this?.media?.length) {
            this.renderUploads();
        }
        if (this.params.remove_all && this.media?.length) {
            this.adRemoveAllButton();
        }
    }

    adRemoveAllButton() {
        const body = mkEl('div', {class: ['remove-all']});
        const del = mkEl('div', {
            html: `Alle Anhänge löschen &#10007;`,
            class: ['button'],
            click: () => this.resetMeta()
        });
        body.append(del);
        this.container.append(body);
    }

    initListeners() {
        if (this.button) {
            this.button.addEventListener('click', (e) => {
                e.preventDefault();
                this.mediaTrigger();
            })
        }
    }

    mediaTrigger() {
        if (this.uploader) {
            this.uploader.open();
            this.uploader.on('select', () => {
                this.uploader.state().get('selection').map(
                    (attachment: any) => {
                        attachment.toJSON();
                        if (!this.media.find(m => m.id === attachment.attributes.id)) {
                            this.media.push({
                                'id': attachment.attributes.id,
                                'name': attachment.attributes.filename,
                                'url': attachment.attributes.url,
                                'mime': attachment.attributes.mime,
                            });
                        }
                        return attachment;
                    });
                this.renderUploads();
            });
        }
    }

    createUploader() {
        if (wp?.media) {
            this.uploader = wp.media.frames.file_frame = wp.media({
                title: 'Anhänge hochladen',
                button: {text: 'Dokumente auswählen'},
                multiple: 'add'
            });
        }
    }

    setMedia(media: Media[]) {
        this.media.push(...media);
        this.renderUploads();
    }

    resetMedia() {
        this.media = [];
        this.container.innerHTML = '';
    }

    resetMeta() {
        console.log(this)
        this.ajx({
            action: 'sta_update_meta',
            pid: this._post_id,
            key: this.params.input_name,
            value: ''
        }).then(() => this.resetMedia());
    }

    renderUploads() {
        this.container.innerHTML = '';
        let ul = mkEl('ul', {class: ['media-list']});
        let fields = mkEl('div', {class: ['media-fields'], style: [{display: 'none'}]});
        if (this?.media?.length) {
            this.media.forEach((m, i) => {
                fields.append(mkEl('input', {
                    type: 'hidden',
                    name: `${this.params.input_name}[${i}]`,
                    value: m.id
                }));
                let li = mkEl('li', {class: ['media-entry']});
                let text = mkEl('span', {text: m.name, class: ['text'], title: m.name});
                let remover = mkEl('span', {html: '&#10006;', class: ['remover'], title: 'Entfernen'});
                remover.addEventListener('click', () => {
                    this.remove(m)
                })
                li.append(text, remover);
                ul.append(li);
            })
        }
        this.container.append(fields, ul);
    }

    remove(media: Media) {
        let i = this.media.indexOf(media);
        if (i > -1) {
            this.media.splice(i, 1);
            this.renderUploads();
        }
    }
}